import { render, staticRenderFns } from "./NotiItem.vue?vue&type=template&id=be969f26&scoped=true&"
import script from "./NotiItem.vue?vue&type=script&lang=js&"
export * from "./NotiItem.vue?vue&type=script&lang=js&"
import style0 from "./NotiItem.vue?vue&type=style&index=0&id=be969f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be969f26",
  null
  
)

export default component.exports